export default __webpack_public_path__ + "static/media/2.f3f6e978.png";